module.exports = __webpack_public_path__ + "img/personality-1.60327bab.svg";